import { createFileRoute } from "@tanstack/react-router";

import { LiveTimelineCanvas } from "@/components/canvas/live-timeline-canvas";

export const Route = createFileRoute("/$workspace/timeline")({
  head: () => ({ meta: [{ title: "Timeline — Dravian Horizon" }] }),
  component: TimelinePage,
});

function TimelinePage() {
  const { workspace } = Route.useParams();
  return <LiveTimelineCanvas workspaceId={workspace} />;
}
